// extracted by mini-css-extract-plugin
module.exports = {"action":"checkoutFooter_action__IWMXK"};